export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL;
export const CLOUDINARY_API_KEY = process.env.REACT_APP_CLOUDINARY_API_KEY;
export const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
